import { Controller } from "@hotwired/stimulus";

// Gemmer skemaet løbende. Formularen indsendes af Turbo, og serveren svarer med
// en Turbo Stream der opdaterer status og periodefanen. Klienten kender derfor ikke
// markuppen for et badge - den kommer fra serveren.
export default class extends Controller {
  static values = { delay: { type: Number, default: 700 } };

  // Et klik på et svar gemmes med det samme.
  save(event) {
    this.clearValidation(event.target);
    this.element.requestSubmit();
  }

  // Fritekst gemmes når skrivningen falder til ro.
  saveLater() {
    clearTimeout(this.timer);
    this.dispatch("pending", { prefix: "autosave", bubbles: true });
    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  // Fjerner markeringen af et manglende svar, så snart spørgsmålet er besvaret.
  clearValidation(input) {
    const row = input.closest("[data-question-row]");
    if (!row) return;

    row.classList.remove("border-danger", "border-2");
    const text = row.querySelector("[data-question-text]");
    if (!text) return;

    text.classList.remove("text-danger", "fw-semibold");
    text.querySelector("[data-missing-marker]")?.remove();
  }

  disconnect() {
    clearTimeout(this.timer);
  }
}
